import React, { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { BorderedCard } from 'components/BorderedCard';
import { TooltipFormImageUpload } from 'components/BusinessToolForm/components/TooltipFormImageUpload/TooltipFormImageUpload';

import { concatWithDot } from 'helpers/string';

import { EQUIPMENT_SECTION_NAMES } from '../utils/form';

export const EquipmentItem: React.FC<{ name: string; isCurrentEquipment?: boolean; disabled?: boolean }> = memo(
  ({ name, isCurrentEquipment, disabled }) => {
    const { t } = useTranslation();
    const { control } = useFormContext();

    return (
      <BorderedCard>
        <Grid container spacing={3}>
          <Grid item xs="auto">
            <TooltipFormImageUpload
              width={136}
              height={136}
              name={concatWithDot(name, EQUIPMENT_SECTION_NAMES.FILE)}
              disabled={disabled}
            />
          </Grid>
          <Grid item xs>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextInputControl
                  control={control}
                  id={concatWithDot(name, EQUIPMENT_SECTION_NAMES.NAME)}
                  name={concatWithDot(name, EQUIPMENT_SECTION_NAMES.NAME)}
                  label={t('businessOperations.equipment.equipmentGroup.name')}
                  disabled={disabled}
                  maxLength={150}
                />
              </Grid>
              <Grid item xs={6}>
                <NumberInputControlled
                  control={control}
                  id={concatWithDot(name, EQUIPMENT_SECTION_NAMES.NUMBER)}
                  name={concatWithDot(name, EQUIPMENT_SECTION_NAMES.NUMBER)}
                  label={t('businessOperations.equipment.equipmentGroup.number')}
                  disabled={disabled}
                />
              </Grid>
              <Grid item xs={6}>
                <NumberInputControlled
                  control={control}
                  id={concatWithDot(name, EQUIPMENT_SECTION_NAMES.COST)}
                  name={concatWithDot(name, EQUIPMENT_SECTION_NAMES.COST)}
                  label={t(
                    isCurrentEquipment
                      ? 'businessOperations.equipment.equipmentGroup.cost'
                      : 'businessOperations.equipment.purchasedEquipment.cost',
                  )}
                  adornmentType="currency"
                  disabled={disabled}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <TextInputControl
              multiline
              control={control}
              id={concatWithDot(name, EQUIPMENT_SECTION_NAMES.PURPOSE)}
              name={concatWithDot(name, EQUIPMENT_SECTION_NAMES.PURPOSE)}
              label={t('businessOperations.equipment.equipmentGroup.purpose')}
              maxLength={150}
              minRows={4}
              disabled={disabled}
            />
          </Grid>
        </Grid>
      </BorderedCard>
    );
  },
);
